/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {UpdateBNoticeSubmissionRequest} from '@cash-web/protos/squareup/cash/piggybank/api/v2/piggybank_service.pb'
import {UpdateBNoticeSubmissionResponse} from '@cash-web/protos/squareup/cash/piggybank/api/v2/piggybank_service.pb'


export const updateBNoticeSubmission = (request: UpdateBNoticeSubmissionRequest, options?: CashRequestOptions) => post<UpdateBNoticeSubmissionRequest, UpdateBNoticeSubmissionResponse>("/2.0/cash/update-b-notice-submission", request, {...options, rejectOnError: true })